export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]').after('[[[Administracja]]]', [
        {
            name: '[[[Wyszukiwanie]]]',
            icon: 'far fa-fw fa-input-pipe',
            namespace: 'Ideo.Core.Common.Application.Permissions.Search',
            children: [
                {
                    name: '[[[Lista indeksów]]]',
                    auth: { all: ['SearchPermissions@Access'], any: [] },
                    route: 'search-indices'
                },
                {
                    name: '[[[Słowa wykluczone]]]',
                    auth: { all: ['StopWordsPermissions@Access'], any: [] },
                    route: 'search-stopwords'
                },
                {
                    name: '[[[Synonimy]]]',
                    auth: { all: ['SynonymsPermissions@Access'], any: [] },
                    route: 'search-synonyms'
                }
            ]
        }
    ]);
};
